
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface SmartMeterReadingsProps {
  device: any;
}

const SmartMeterReadings: React.FC<SmartMeterReadingsProps> = ({ device }) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">Meter Readings</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Voltage</p>
            <p className="text-lg font-bold">{device.readings.voltage} V</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Current</p>
            <p className="text-lg font-bold">{device.readings.current} A</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Frequency</p>
            <p className="text-lg font-bold">{device.readings.frequency} Hz</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Power</p>
            <p className="text-lg font-bold">{device.readings.power.toFixed(1)} W</p>
          </div>
          <div className="border rounded-lg p-3">
            <p className="text-xs text-muted-foreground">Total Energy</p>
            <p className="text-lg font-bold">{device.readings.totalEnergy.toFixed(1)} kWh</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SmartMeterReadings;
